<script setup>
import { useI18n } from 'vue-i18n';
import Button from 'dashboard/components-next/button/Button.vue';

defineProps({ current: { type: Object, required: true } });
defineEmits(['review']);
const { t } = useI18n();
</script>

<template>
  <section
    role="status"
    class="flex flex-col gap-2 rounded-lg border border-n-weak bg-n-solid-2 p-3"
  >
    <p class="m-0 text-sm font-medium">{{ t('KANBAN.CONFLICT.TITLE') }}</p>
    <p class="m-0 text-xs">{{ t('KANBAN.CONFLICT.DESCRIPTION') }}</p>
    <details class="text-xs">
      <summary class="cursor-pointer">
        {{ t('KANBAN.CONFLICT.CURRENT') }}
      </summary>
      <dl
        class="mt-2 grid max-h-52 grid-cols-1 gap-1 overflow-y-auto break-words"
      >
        <dt>{{ t('KANBAN.DEAL_TITLE_LABEL') }}</dt>
        <dd class="m-0">{{ current.title || '—' }}</dd>
        <dt>{{ t('KANBAN.DEAL_LABELS.TITLE') }}</dt>
        <dd class="m-0">
          {{
            Array.isArray(current.labels)
              ? current.labels.map(label => label.name).join(', ') ||
                t('KANBAN.DEAL_LABELS.EMPTY')
              : t('KANBAN.DEAL_LABELS.UNKNOWN')
          }}
        </dd>
        <dt>{{ t('KANBAN.PRODUCT_LABEL') }}</dt>
        <dd class="m-0">{{ current.product_name || '—' }}</dd>
        <dt>{{ t('KANBAN.DEAL_VALUE_LABEL') }}</dt>
        <dd class="m-0">{{ current.deal_value ?? '—' }}</dd>
        <dt>{{ t('KANBAN.LEAD_SOURCE_LABEL') }}</dt>
        <dd class="m-0">{{ current.lead_source || '—' }}</dd>
        <dt>{{ t('KANBAN.CLOSE_DATE_LABEL') }}</dt>
        <dd class="m-0">{{ current.expected_close_date || '—' }}</dd>
        <dt>{{ t('KANBAN.SIDEBAR.SELECT_STAGE') }}</dt>
        <dd class="m-0">{{ current.kanban_stage?.name || '—' }}</dd>
        <dt>{{ t('CONVERSATION_SIDEBAR.ASSIGNEE_LABEL') }}</dt>
        <dd class="m-0">
          {{ current.assignee?.name || t('KANBAN.SIDEBAR.NO_ASSIGNEE') }}
        </dd>
        <dt>{{ t('KANBAN.NOTES_LABEL') }}</dt>
        <dd class="m-0 whitespace-pre-wrap">{{ current.notes || '—' }}</dd>
      </dl>
    </details>
    <Button
      size="sm"
      :label="t('KANBAN.CONFLICT.REVIEW')"
      @click="$emit('review')"
    />
  </section>
</template>
